// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"618":"791c0aa695a9446af2cc","788":"93db888480a5805836bb"}[chunkId] + ".js";
};